module.exports = __webpack_public_path__ + "static/img/help_09study_04.bc44aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_09study_04.png
// module id = 708
// module chunks = 140